import { TabsInterfaceNew } from '@prometheus/types';
import i18n from 'i18next';
export const tabs = (): TabsInterfaceNew[] => [
  {
    value: '',
    title: i18n.t('modules.administration.vocabulary_management.tabs.bandles'),
    end: true,
  },
  {
    value: 'downloaded',
    title: i18n.t(
      'modules.administration.vocabulary_management.tabs.downloaded'
    ),
  },
];
